<template>
  <div class="login">
    <div class="text-center my-3 ">
      <button
        name=""
        id="sign"
        :class="[front ? 'blue-gradient' : 'aqua-gradient', bgColor]"
        type="button"
        @click="togglePage()"
      >
        {{ front ? "Inscription" : "Connexion" }}
      </button>
    </div>

    <div class="cont" :style="styleObject">
      <div class="front" :style="[front ? 'z-index : 2;' : 'z-index : 1;']">
        <!-- Material form login -->
        <div class="card ">
          <h5 class="card-header blue-gradient white-text text-center py-4">
            <strong>Connexion</strong>
          </h5>

          <!--Card content-->
          <div class="card-body px-lg-5 pt-0 pb-5">
            <!-- Form -->
            <form
              class="text-center"
              style="color: #757575;"
              @submit.prevent="login_m()"
            >
              <!-- Email -->
              <div class="md-form">
                <input
                  type="email"
                  id="emailEnt"
                  v-model.trim="login.email"
                  class="form-control"
                />
                <label for="emailEnt">E-mail</label>
              </div>

              <!-- Password -->
              <div class="md-form">
                <input
                  type="password"
                  id="mdpEnt"
                  v-model="login.password"
                  class="form-control"
                />
                <label for="mdpEnt">Mot de passe</label>
              </div>
              <p class="error text-danger text-center">
                {{ error }}
              </p>
              <div class="d-flex justify-content-around">
                <div>
                  <!-- Forgot password -->
                  <a
                    href="#"
                    id="moub"
                    data-target="#modalContactForm"
                    data-toggle="modal"
                    >mot de passe oublié ?</a
                  >
                </div>
              </div>

              <!-- Sign in button -->
              <button
                class="btn btn-outline-info btn-rounded btn-block my-4 waves-effect z-depth-0"
                id="btnEnt"
                @click="login_m()"
              >
                Connexion
              </button>

              <!-- Register -->
              <p>
                Pas un membre?
                <span class="text-primary">inscrivez vous</span>
              </p>

              <!-- Social login -->
              <p>ou connectez-vous avec:</p>
              <a type="button" class="btn-floating btn-fb btn-sm">
                <i class="fab fa-facebook-f"></i>
              </a>
              <a type="button" class="btn-floating btn-tw btn-sm">
                <i class="fab fa-twitter"></i>
              </a>
              <a type="button" class="btn-floating btn-li btn-sm">
                <i class="fab fa-linkedin-in"></i>
              </a>
              <a type="button" class="btn-floating btn-git btn-sm">
                <i class="fab fa-github"></i>
              </a>
            </form>
            <!-- Form -->

            <!-- <img src="@/assets/image/phoneMoc2.png" style="position:absolute; z-index:6;bottom:0;left:0;" alt="" srcset=""> -->
          </div>
          <img
            class="mock"
            src="@/assets/image/stetho copie.png"
            alt=""
            srcset=""
          />
        </div>
        <!-- Material form login -->
      </div>

      <div class="back mb-3">
        <div class="form-container d-flex justify-content-center">
          <div class="card">
            <h5 class="card-header aqua-gradient white-text text-center py-4">
              <strong>Inscription</strong>
            </h5>
            <div class="card-body px-lg-5 pt-0">
              <form
                class="text-center"
                style="color: #757575;"
                @submit.prevent="sign_up_m()"
              >
                <div class="form-row">
                  <div class="col">
                    <div class="md-form">
                      <input
                        type="text"
                        id="FirstName"
                        class="form-control"
                        v-model.trim="sign_up.first_name"
                      />
                      <label for="FirstName">Prénom</label>
                    </div>
                  </div>
                  <div class="col">
                    <div class="md-form">
                      <input
                        type="text"
                        id="LastName"
                        class="form-control"
                        v-model.trim="sign_up.last_name"
                      />
                      <label for="LastName">nom de famille</label>
                    </div>
                  </div>
                </div>
                <div class="md-form mt-0">
                  <input
                    type="email"
                    id="emailIns"
                    class="form-control"
                    v-model.trim="sign_up.email"
                  />
                  <label for="emailIns">E-mail</label>
                </div>
                <div class="md-form">
                  <input
                    type="password"
                    id="mdpIns"
                    class="form-control"
                    v-model="sign_up.password"
                  />
                  <label for="mdpIns">Mot de passe</label>
                </div>
                <div class="md-form">
                  <input
                    type="text"
                    id="numIns"
                    class="form-control"
                    v-model.trim="sign_up.phone_number"
                  />
                  <label for="numIns">Numéro de télephone</label>
                </div>
                <div class="md-form">
                  <input
                    placeholder="Date de naissance"
                    type="date"
                    id="dateIns"
                    v-model="sign_up.date_naiss"
                    class="form-control"
                  />
                  <label for="dateIns" class="mt-2">Date de naissance</label>
                </div>
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    class="custom-control-input"
                    id="defaultUnchecked"
                    value="Homme"
                    v-model="sign_up.gender"
                    checked
                  />
                  <label class="custom-control-label" for="defaultUnchecked"
                    >Homme</label
                  >
                </div>
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    class="custom-control-input"
                    id="defaultChecked"
                    value="Femme"
                    v-model="sign_up.gender"
                  />
                  <label class="custom-control-label" for="defaultChecked"
                    >Femme</label
                  >
                </div>
                <button
                  class="btn btn-outline-info btn-rounded btn-block my-4 waves-effect z-depth-0"
                  id="btnIns"
                  @click="sign_up_m()"
                >
                  Inscription
                </button>
                <p>or sign up with:</p>
                <a type="button" class="btn-floating btn-fb btn-sm">
                  <i class="fab fa-facebook-f"></i>
                </a>
                <a type="button" class="btn-floating btn-tw btn-sm">
                  <i class="fab fa-twitter"></i>
                </a>
                <a type="button" class="btn-floating btn-li btn-sm">
                  <i class="fab fa-linkedin-in"></i>
                </a>
                <a type="button" class="btn-floating btn-git btn-sm">
                  <i class="fab fa-github"></i>
                </a>
                <hr />
                <p>
                  En cliquant sur , <em>Inscription</em> vous acceptez nos
                  <a href="terms.html" target="_blank"
                    >Conditions d’Utilisation</a
                  >
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from "@/firebase";
import { db } from "@/firebase";

export default {
  data() {
    return {
      front: true,
      bgColor: "text-white btn btn-rounded",
      deg: 0,
      styleObject: {
        transform: "rotateY(0 deg)"
      },
      login: {
        email: "",
        password: ""
      },
      sign_up: {
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        phone_number: null,
        date_naiss: null,
        gender: "Homme"
      },
      error: ""
    };
  },
  methods: {
    togglePage() {
      this.front = !this.front;
      this.deg += 180;
      this.styleObject.transform = "rotateY(" + this.deg + "deg)";
    },
    login_m() {
      console.log(this.login);
      auth
        .signInWithEmailAndPassword(this.login.email, this.login.password)
        .then(data => {
          try {
            console.log(data);

            this.$router.replace({ name: "Home" });
          } catch (err) {
            console.log(err);
          }
        })
        .catch(error => {
          // Handle Errors here.
          this.error = error.message;
          var errorCode = error.code;
          if (errorCode == "auth/wrong-password") {
            console.log("inccorecct");
          }
        });
    },
    sign_up_m() {
      try {
        auth.useDeviceLanguage();
        auth
          .createUserWithEmailAndPassword(
            this.sign_up.email,
            this.sign_up.password
          )
          .catch(function(error) {
            var errorCode = error.code;
            alert("createUserWithEmailAndPassword " + errorCode, error);
          });

        auth.onAuthStateChanged(user => {
          if (user) {
            db.ref()
              .child("users/" + user.uid)
              .set({
                Email: this.sign_up.email,
                First_name: this.sign_up.first_name,
                Last_name: this.sign_up.last_name,
                Profile_Image: "",
                UID: user.uid,
                adress: "",
                birthday: this.sign_up.date_naiss,
                description: "",
                password: this.sign_up.password,
                phone: this.sign_up.phone_number,
                sex: this.sign_up.gender
              });
          }
        });
      } catch (error) {
        alert("error catch " + error);
      }
    }
  }
};
</script>


<style lang="scss" scoped>
body {
  -webkit-animation: color-change-2x 2s linear infinite alternate both;
  animation: color-change-2x 2s linear infinite alternate both !important;
}

@-webkit-keyframes color-change-2x {
  0% {
    background: #19dcea;
  }

  100% {
    background: #2c32ff;
  }
}

@keyframes color-change-2x {
  0% {
    background: #19dcea;
  }

  100% {
    background: #2c32ff;
  }
}

.cont {
  max-width: 560px;
  height: calc(100vh + 180px);
  margin: 0px auto;
  position: relative;
  transform-style: preserve-3d;
  transition: all 0.9s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.front {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  z-index: 2;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
}

.back {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  transform: rotateY(180deg);
  z-index: 1;
}

.btn-rounded {
  border-radius: 10em;
}

#sign {
  transition: all 0.9s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.mock {
  width: 190px;
  position: absolute;
  bottom: -40px;
  right: -10px;
  z-index: 5;
}
</style>